import { render, staticRenderFns } from "./ShareForm.vue?vue&type=template&id=417262e3&"
import script from "./ShareForm.vue?vue&type=script&lang=js&"
export * from "./ShareForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('417262e3')) {
      api.createRecord('417262e3', component.options)
    } else {
      api.reload('417262e3', component.options)
    }
    module.hot.accept("./ShareForm.vue?vue&type=template&id=417262e3&", function () {
      api.rerender('417262e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/ubossOnePage/ShareForm.vue"
export default component.exports